import { DiagramDefinition } from "../types";

export const m017Definition: DiagramDefinition = {
  id: "M-017",
  title: "Migration Rollback Mechanics",
  description:
    "Symmetric up() and down() migration execution paths for schema modifications (CREATE TABLE -> DROP TABLE, ALTER TABLE -> Revert ALTER).",
  viewBox: "0 0 800 280",
  nodes: [
    // Up Execution Column
    { id: "A", kind: "service", label: "001_create_posts.js", subtext: "Migration 001", position: [140, 70], size: [160, 44] },
    { id: "B", kind: "service", label: "up: CREATE TABLE", subtext: "Apply Schema", position: [400, 70], size: [160, 44], statusColor: "#ff5a1f" },
    { id: "C", kind: "service", label: "002_add_roles.js", subtext: "Migration 002", position: [140, 130], size: [160, 44] },
    { id: "D", kind: "service", label: "up: ALTER TABLE", subtext: "Apply Schema", position: [400, 130], size: [160, 44], statusColor: "#ff5a1f" },

    // Down Execution Column
    { id: "E", kind: "service", label: "down: Revert ALTER", subtext: "Rollback Step 1", position: [660, 130], size: [160, 44], statusColor: "#f59e0b" },
    { id: "F", kind: "service", label: "down: DROP TABLE", subtext: "Rollback Step 2", position: [660, 210], size: [160, 44], statusColor: "#f59e0b" },
  ],
  edges: [
    { id: "e1", source: "A", target: "B", sourcePort: "right", targetPort: "left", routing: "straight", animated: true },
    { id: "e2", source: "C", target: "D", sourcePort: "right", targetPort: "left", routing: "straight", animated: true },
    { id: "e3", source: "D", target: "E", sourcePort: "right", targetPort: "left", routing: "straight" },
    { id: "e4", source: "B", target: "F", sourcePort: "right", targetPort: "left", routing: "orthogonal", midOffset: 550 },
  ],
};
